export const bundlesWithVisibleLanguage = []
export const bundlesWithHiddenGlobally = []

export const globalOptionsDefaults = {
  "bkVisibleLanguages": {
    "default": [],
    "type": "checkboxes"
  },
  "bkHiddenGlobally": {
    "default": false,
    "type": "checkbox"
  },
  "teaserStyle": {
    "default": "grid",
    "type": "radios"
  },
  "mobileStyle": {
    "default": "stapel",
    "type": "radios"
  },
  "spacing": {
    "default": "none",
    "type": "radios"
  }
}